import { Button } from '@/components/shadcn/button'
import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { useSessionStorage } from '@/hooks/useSessionStorage'
import { isPlatformAdmin, isProjectLeader, isSuperUser } from '@/util'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { OrganisationDetailsForm } from '../Forms/OrganisationDetailsForm'
import { RequestAddOrganisationForm } from '../Forms/RequestAddOrganisationForm'
import { columns } from './SubscriptionsTable/subscriptionTableColumns'
import { Link } from 'react-router'

export function SubscriptionsTable() {
  const { getSubscriptionsApiGetOrganisations } = useRestClient()
  const { data: organisations } = getSubscriptionsApiGetOrganisations.useSuspenseQuery(undefined)
  const [userRole] = useSessionStorage('roles', 1)
  const canAddOrg = isSuperUser(userRole)
  const canViewPlatformRequests = isSuperUser(userRole)
  const canRequestOrg = isPlatformAdmin(userRole) || isProjectLeader(userRole) || isSuperUser(userRole)

  return (
    <DataTable
      title="Organisations"
      columns={columns}
      data={organisations}
      action={
        <div className="flex items-center gap-2">
          {canViewPlatformRequests && (
            <Button size="sm" variant="ghost" asChild>
              <Link to="/platform/requests">Platform requests</Link>
            </Button>
          )}
          {canRequestOrg && (
            <RequestAddOrganisationForm
              sheetTitle="Request new organisation"
              sheetTrigger={
                <Button size="sm" variant="outline">
                  <IconPlusOutline className="mr-2 size-4" />
                  Request organisation
                </Button>
              }
            />
          )}
          <OrganisationDetailsForm
            sheetTitle="Add organisation"
            sheetDescription="Add a new organisation to your subscription."
            sheetTrigger={
              <Button size="sm" disabled={!canAddOrg} variant="outline">
                <IconPlusOutline className="mr-2 size-4" />
                Add organisation
              </Button>
            }
          />
        </div>
      }
    />
  )
}
